import { useEffect } from "react";
import "./Search_product_offcanvas.css";
import Offcanvas from "react-bootstrap/Offcanvas";
import Form from "react-bootstrap/Form";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import {
  getAllProducts,
  ProductSearch,
  SendWhatAppContact,
} from "../../../../features/products/productsSlice";
import { Link, useNavigate } from "react-router-dom";
import { getAllCategories } from "../../../../features/master/masterSlice";
import { encodeId } from "../../../../utils/common";

const Search_product_offcanvas = ({
  filters,
  onFilterChange,
  show,
  onHide,
  ...props
}) => {
  const { register, getValues } = useForm();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const topframes = useSelector((state) => state.product.allProducts);

  // Trigger product fetch when the component mounts or filters change
  // useEffect(() => {
  //   dispatch(getAllProducts({ filters, page: 1 })); // Default to page 1
  // }, [dispatch, filters]);

  useEffect(() => {
    console.log("gggggg KKKKKK");

    dispatch(getAllProducts({ filters, page: 1 }));
  }, [filters, dispatch]);

  console.log(filters, "filters filters");

  // Handle search input change for real-time filtering
  const handleInputChange = () => {
    const name = getValues("name") || "";
    onFilterChange("name", name);
  };

  // Use topframes.data for products (assuming topframes.data is the array of products)
  const products = topframes?.data || [];

  // Rely on backend filtering, no additional client-side filtering
  const filteredProducts = products;

  const handleProductClick = (product) => {
    const query = filters.name
      ? `?name=${encodeURIComponent(filters.name)}`
      : "";
    navigate(`/all-products${query}`);
    onHide();
  };

  const handleProductClickDescription = (data) => {
    navigate(`/product-descrption/${encodeId(data?.id)}`);
    onHide();
  };

  const allCategories = useSelector((state) => state.master.categories);
  useEffect(() => {
    dispatch(getAllCategories());
  }, [dispatch]);

  const handleClick = async () => {
    let name = getValues("name");
    onFilterChange("name", name);
    const res = await dispatch(ProductSearch({ name: name }));
  };
  return (
    <>
      {["top"].map((placement, idx) => (
        <Offcanvas
          className="Search_product_offcanvas"
          show={show}
          onHide={onHide}
          key={idx}
          placement="top"
          name={placement}
          {...props}
        >
          <div className="container">
            <Offcanvas.Header closeButton />
            <Offcanvas.Body>
              <div className="row">
                <div className="col-lg-10 mx-auto">
                  <h1 className="whattitle">What Are You Looking For?</h1>
                  <div className="searchproddiv">
                    <Form.Control
                      type="search"
                      placeholder="I'm looking for..."
                      {...register("name", {
                        required: "Name is required",
                      })}
                      // {...register("name", {
                      //   onChange: handleInputChange, // Trigger filtering on input change
                      // })}
                    />
                    <button className="searchbtn" onClick={handleClick}>
                      <img
                        // onClick={handleInputChange}
                        className="icon"
                        src={
                          process.env.PUBLIC_URL +
                          "/assets/images/icons/search2.png"
                        }
                        alt="search"
                      />
                    </button>
                  </div>

                  <div className="recent_searches">
                    <p className="quickp">
                      <p className="mb-0">Quick Search:</p>

                      {allCategories?.map((val, idx) => (
                        <span
                          key={idx}
                          onClick={() => {
                            onFilterChange("category", {
                              id: val?.id,
                              name: val.name,
                            });
                          }}
                          style={{
                            textDecoration: filters?.category?.some(
                              (c) => c.id === val.id,
                            )
                              ? "underline"
                              : "none",
                            cursor: "pointer",
                          }}
                        >
                          {val?.name}
                          {idx < allCategories.length - 1 && <>,&nbsp;</>}
                        </span>
                      ))}
                      {/* <span
                        onClick={() => onFilterChange("name", "Sunglasses")}
                      >
                        Sunglasses
                      </span>
                      ,&nbsp;
                      <span
                        onClick={() => onFilterChange("name", "Contact Lenses")}
                      >
                        Contact Lenses
                      </span> */}
                    </p>
                  </div>

                  <div className="popproddiv">
                    <h6 className="poptitle">
                      {filters.name ? "Search Results" : "All Products"}
                    </h6>
                    <div className="header_popproddiv_itmes_holder">
                      {filteredProducts.length > 0 ? (
                        <div className="row ms-0 me-0">
                          {filteredProducts.map((data, index) => (
                            <div
                              className="col-md-2 col-sm-3 col-4 mb-2 p-md-2 p-1"
                              key={index}
                              onClick={() =>
                                handleProductClickDescription(data)
                              }
                              style={{ cursor: "pointer" }}
                            >
                              {/* <Link
                              // to={`/product-descrption/${encodeId(data?.id)}`}
                              style={{
                                textDecoration: "none",
                                color: "inherit",
                              }}
                            > */}
                              <div className="productdiv">
                                <div className="img_div">
                                  <img
                                    className="gogleimg"
                                    src={
                                      process.env.REACT_APP_IMAGE_URL +
                                      data?.image
                                    }
                                    alt={data?.Brand?.name || "Product"}
                                  />
                                </div>
                                <p className="prodname">
                                  {data?.name || "Unknown"}
                                </p>
                                <p className="prise">
                                  Rs.{data?.price || "N/A"}
                                </p>
                              </div>
                              {/* </Link> */}
                            </div>
                          ))}
                        </div>
                      ) : (
                        <p>No products found.</p>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </Offcanvas.Body>
          </div>
        </Offcanvas>
      ))}
    </>
  );
};

export default Search_product_offcanvas;
